import { MsiAutofocusModule } from './../../../directives/autofocus/autofocus.module';
import { NgModule } from '@angular/core';

import { TwoFactorFormComponent } from './two-factor-auth.component';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MsiTextToggleModule } from '@msi/ionic/ui/msi-text-toggle/msi-text-toggle.module';

@NgModule({
  declarations: [
    TwoFactorFormComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    MsiAutofocusModule,
    FlexLayoutModule,
    MsiTextToggleModule,
  ],
  exports: [
    TwoFactorFormComponent
  ]
})
export class MsiTwoFactorAuthFormModule { }
